import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../testnurse/service/service.component';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, IvfPlanTemplateController, IvfPlanTemplateRequest, SaveIvfPlanTemplateRequest, IvfPlanActivityTemplateController, IvfPlanActivityTemplateRequest, SaveIvfPlanActivityTemplateRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { NgbAddactivitytemplateModal } from './addactivitytemplate.modal';
import { NgbEditactivitytemplateModal } from './editactivitytemplate.modal';
import { NgbAddactivitiesModal } from './addactivities.modal';
import { NgbEditactivitiesModal } from './editactivities.modal';




@Component({
  selector: 'ivfmasterlist',
  templateUrl: './ivfmasterlist.component.html',
  styleUrls: ['./ivfmasterlist.component.scss']
})

export class IvfmasterlistComponent implements OnInit {
 
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
 
  public Date: Date;
  public ShowActivity: boolean = false;

  CurrentSaveIvfPlanTemplateRequest: SaveIvfPlanTemplateRequest;
  CurrentEditIvfPlanTemplateRequest: SaveIvfPlanTemplateRequest;
  CurrentEditIvfPlanActivityTemplateRequest: SaveIvfPlanActivityTemplateRequest;
  CurrentIvfPlanTemplateController: IvfPlanTemplateController;
  CurrentIvfPlanTemplateRequest: IvfPlanTemplateRequest;
  LoadIvfTemplate() {
    this.StartRefreshing();


   

    this.CurrentIvfPlanTemplateRequest = new IvfPlanTemplateRequest();
    this.CurrentIvfPlanTemplateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.CurrentServiceBranchMapByFormattedCodeRequest.FormattedCode = 2; // registries  
    
    this.GetIvfPlanTemplateController();




  }
  GetIvfPlanTemplateController() {
    this.StartRefreshing();
    //this.CurrentServiceCategoriesRequest.ParentCode = -1;
    this.CurrentIvfPlanTemplateRequest.ConditionalOperator = 10;
    this.actorservice.GetIvfPlanTemplateController(this.CurrentIvfPlanTemplateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentIvfPlanTemplateController = this.ApiResData.Result;
          //this.pdata = this.CurrentServiceCategoriesController;
          //alert(this.CurrentServiceCategoriesController.length);
          //this.ShowService = false;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }



  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
   
    this.Date = new Date();
    this.LoadIvfTemplate();
    this.CurrentEditIvfPlanTemplateRequest = new SaveIvfPlanTemplateRequest();
    this.CurrentEditIvfPlanTemplateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentEditIvfPlanActivityTemplateRequest = new SaveIvfPlanActivityTemplateRequest();
    this.CurrentEditIvfPlanActivityTemplateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }

  Addactivity() {
    const modalRef = this.modalService.open(NgbAddactivitytemplateModal,
      {
        centered: true

      })
    modalRef.result.then(x => {this.GetIvfPlanTemplateController()})
  }
  Editactivity(l: IvfPlanTemplateController) {
    this.CurrentEditIvfPlanTemplateRequest.Protocol = l.Protocol
    this.CurrentEditIvfPlanTemplateRequest.CycleType = l.CycleType;
    this.CurrentEditIvfPlanTemplateRequest.TemplateCode = l.PlanTemplateCode;
    const modalRef = this.modalService.open(NgbEditactivitytemplateModal,
      {
        centered: true

      })
    modalRef.componentInstance.CurrentEditIvfPlanTemplateRequest = this.CurrentEditIvfPlanTemplateRequest;
   modalRef.result.then(x => { this.GetIvfPlanTemplateController() })
  }
  
 
  
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  SelectedTemplate: IvfPlanTemplateController;
  ViewSelectedTemplate(objCategory: any) {
    var Template: IvfPlanTemplateController = objCategory;
    if (Template != null) {
      this.SelectedTemplate = Template;
      this.ShowActivity = true;
      this.LoadIvfPlanActivity();
    }
    else {

    }
  }
  CurrentIvfPlanActivityTemplateController: IvfPlanActivityTemplateController;
  CurrentIvfPlanActivityTemplateRequest: IvfPlanActivityTemplateRequest;
  LoadIvfPlanActivity() {
    this.CurrentIvfPlanActivityTemplateRequest = new IvfPlanActivityTemplateRequest();
    this.CurrentIvfPlanActivityTemplateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfPlanActivityTemplateController();
  }
  GetIvfPlanActivityTemplateController() {
    this.StartRefreshing();
    //this.CurrentServiceCategoriesRequest.ParentCode = -1;
    this.CurrentIvfPlanActivityTemplateRequest.PlanTemplateCode = this.SelectedTemplate.PlanTemplateCode;
    this.CurrentIvfPlanActivityTemplateRequest.ConditionalOperator = 10;
    this.actorservice.GetIvfPlanActivityTemplateController(this.CurrentIvfPlanActivityTemplateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentIvfPlanActivityTemplateController = this.ApiResData.Result;
          //this.pdata = this.CurrentServiceCategoriesController;
          //alert(this.CurrentServiceCategoriesController.length);
          //this.ShowService = false;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  Addactivities() {
    const modalRef = this.modalService.open(NgbAddactivitiesModal,
      {
        centered: true

      })
    modalRef.componentInstance.TemplateCode = this.SelectedTemplate.PlanTemplateCode;
    modalRef.componentInstance.CycleType = this.SelectedTemplate.CycleType;
    modalRef.componentInstance.Protocol = this.SelectedTemplate.Protocol;
    modalRef.result.then(x => { this.GetIvfPlanActivityTemplateController() })
  }
  Editactivities(l: IvfPlanActivityTemplateController) {
    this.CurrentEditIvfPlanActivityTemplateRequest.ActivityDescription = l.ActivityDescription
    this.CurrentEditIvfPlanActivityTemplateRequest.ActivityTemplateCode = l.ActivityTemplateCode;
    this.CurrentEditIvfPlanActivityTemplateRequest.ActivityType = l.ActivityType;
    this.CurrentEditIvfPlanActivityTemplateRequest.ApplicableTo = l.ApplicableTo;
    this.CurrentEditIvfPlanActivityTemplateRequest.DOC = l.DOC;
    this.CurrentEditIvfPlanActivityTemplateRequest.SeqNo = l.SeqNo;
    this.CurrentEditIvfPlanActivityTemplateRequest.Remarks = l.Remarks;
    this.CurrentEditIvfPlanActivityTemplateRequest.TemplateCode = this.SelectedTemplate.PlanTemplateCode;
    this.CurrentEditIvfPlanActivityTemplateRequest.Protocol = this.SelectedTemplate.Protocol;
    this.CurrentEditIvfPlanActivityTemplateRequest.CycleType = this.SelectedTemplate.CycleType;
    this.CurrentEditIvfPlanActivityTemplateRequest.ServiceName = l.ServiceName;
    this.CurrentEditIvfPlanActivityTemplateRequest.ServiceCode = l.ServiceCode;
    const modalRef = this.modalService.open(NgbEditactivitiesModal,
      {
        centered: true

      })
    modalRef.componentInstance.CurrentEditIvfPlanActivityTemplateRequest = this.CurrentEditIvfPlanActivityTemplateRequest;
    modalRef.result.then(x => { this.GetIvfPlanActivityTemplateController() })
  }
  criteriaChange(value: any) {
   
  }

}


 
 
 



